export * from './delete-ort-kategorie-request.interface';
export * from './delete-ort-kategorie-response.interface';
export * from './delete-ort-kategorie.shapes';
